<template>
    <edit></edit>
</template>
<script>
    import edit from './stationed_operation_guide_edit.vue'

    export default {
        name: 'stationed_operation_guide_add',

        components: {
            edit
        }
    }
</script>
